@if (!!customerModel.cards.length) {
<form #form="ngForm"
      method="POST">
    @for (card of customerModel.cards; track $index) {
    <div class="c-6-set c-12-s p-a-4 p-b-6-s bg-col-33 b-radius-20 m-b-5-s">
        <div class="flex-grow lh-1">
            <div class="pos-relative">
                <div class="flex p-r-8">
                    <div class="payment-logos p-r-2">
                        <div [ngClass]="'logo-' + (card.data.type | lowercase)"></div>
                    </div>
                    <div [sizeClass]="'XL:p2,SM:p1'">
                        <span class="block">
                            {{card.data.type}} - xxxx <span data-cs-mask>{{card.data.last_four}}</span>
                        </span>
                        {{'Exp' | translate}}&nbsp;<span data-cs-mask>{{card.data.expiry_date}}</span>
                        <br>
                    </div>
                </div>

                <div class="m-t-1-l m-t-2 p-l-4 p-l-3-x p-l-5-m p-l-6-s">
                    <radio class="radio"
                           [ngClass]="{'is-checked pointer-events-none': card.data.is_default, 'busy' : card.setCardDefaultStatus.busy}"
                           name="defaultCard"
                           [(ngModel)]="card.data.is_default"
                           (click)="card.setDefault()">
                        <span class="block p1 p-l-4-l p-l-3-x p-l-6-s"
                              [ngClass]="{'fw-bold': card.data.is_default}">{{'Default payment' | translate}}</span>
                    </radio>
                </div>

                <div class="pos-absolute top-0 right-0 top-1-s right-1-s">
                    <action class="button-inline"
                            [attr.aria-label]="'Remove card' | translate"
                            [status]="card.removeStatus"
                            (click)="card.remove()">
                        <i class="icon-trash fs-6"
                           aria-hidden="true"></i>
                    </action>
                    <result [status]="card.removeStatus" />
                </div>
            </div>
        </div>
    </div>
    }
</form>
} @else {
<p class="p1 p-l-2">{{'You don\'t have any saved cards.' | translate}}</p>
}